export default __webpack_public_path__ + "static/media/fbc.11906c18.png";